import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import tradeRequestApi from '../../sources/api/tradeRequestApi';

// constants
import { CANCEL_TRADE_REQUEST } from '../../constants/tradeOffersTypes';

// lib
import httpSaga from '../../lib/httpSaga';
import { toastr } from 'react-redux-toastr';
import { CANCEL_TRADE_REQUEST_ERROR, CANCEL_TRADE_REQUEST_SUCCESS,  } from '../../constants/messages';

export function* cancelTradeRequest(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(CANCEL_TRADE_REQUEST, call(tradeRequestApi.cancelTradeRequest, params));
    yield toastr.success('success', CANCEL_TRADE_REQUEST_SUCCESS);
  } catch (e) {
    if (e.response) {
      yield toastr.error(e.response.body.message);
    } else {
      yield toastr.error(CANCEL_TRADE_REQUEST_ERROR);
    }
    yield put(error(CANCEL_TRADE_REQUEST, e));
  } finally {
    yield put(doneIndicator(CANCEL_TRADE_REQUEST));
  }
}

export function* watchcancelTradeRequest() {
  yield takeEvery(CANCEL_TRADE_REQUEST, cancelTradeRequest);
}

export default function* root() {
  yield all([
    fork(watchcancelTradeRequest)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/tradeOffers/cancelTradeRequest.js